"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.appSessionStorage = exports.appStorage = void 0;
require("./types");
const singletonLocalStorage = Symbol('localStorage');
const singletonSessionStorage = Symbol('sessionStorage');
class Storage {
    constructor(sessionMode = false) {
        this.storage = sessionMode ? window.sessionStorage : window.localStorage;
    }
    setItem(name, value) {
        const stringValue = Storage.toStringValue(value);
        this.storage.setItem(name, stringValue);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getItem(name, initialValue) {
        const item = this.storage.getItem(name);
        if (!item) {
            return initialValue || null;
        }
        try {
            return JSON.parse(item);
        }
        catch (e) {
            return item;
        }
    }
    removeItem(name) {
        this.storage.removeItem(name);
    }
    clear() {
        this.storage.clear();
    }
    static get instanceLocalStorage() {
        if (!this[singletonLocalStorage]) {
            this[singletonLocalStorage] = new Storage(false);
        }
        return this[singletonLocalStorage];
    }
    static get instanceSessionStorage() {
        if (!this[singletonSessionStorage]) {
            this[singletonSessionStorage] = new Storage(true);
        }
        return this[singletonSessionStorage];
    }
    static toStringValue(value) {
        return typeof value !== 'string' ? JSON.stringify(value) : value;
    }
}
exports.appStorage = Storage.instanceLocalStorage;
exports.appSessionStorage = Storage.instanceSessionStorage;
//# sourceMappingURL=Storage.js.map